'use client';

import { convertElevation } from '@streetferret/geospatial/conversions';
import { formatDistance } from '@streetferret/utils';
import { usePreferences } from '@streetferret/providers';
import { cn } from '@streetferret/utils';

interface ElevationProps {
  /**
   * Elevation in meters.
   */
  elevation: number;
  /**
   * Number of digits to display after the decimal point.
   * @default 2
   */
  decimals?: number;
  /**
   * Optional className to override styles
   */
  className?: string;
}
/**
 * Displays elevation in a human-readable format, converting for the user's unit preference.
 */
export function Elevation({
  elevation,
  decimals = 0,
  className,
}: ElevationProps) {
  const { unit } = usePreferences();

  const convertedElevation = convertElevation(
    elevation,
    'meters',
    unit === 'imperial' ? 'feet' : 'meters',
  );
  const unitNiceName = unit === 'imperial' ? 'ft' : 'm';
  const formattedElevation = formatDistance(convertedElevation, decimals);
  return (
    <span className={cn('tabular-nums inline-flex gap-1', className)}>
      <span>{formattedElevation}</span>
      <span>{unitNiceName}</span>
    </span>
  );
}
